import { CHARACTER_GROVE_RESPONSE_1 } from './content/CharacterGroveStories.js';
import { SILENT_STORY_TREE_TRAIL } from './content/SilentStoryTreeStories.js';
import { WORD_GARDEN_CONTEXT_1 } from './content/WordGardenVocabulary.js';
import { STORY_FOREST_DISTRICTS, type StoryForestDistrict } from './StoryForestState.js';

export interface StoryForestDistrictConfig {
  id: StoryForestDistrict;
  name: string;
  curriculumFocus: readonly string[];
  openingChallengeId?: string;
  availableInFoundation: boolean;
}

export const STORY_FOREST_DISTRICT_CONFIGS: readonly StoryForestDistrictConfig[] = [
  {
    id: STORY_FOREST_DISTRICTS.silentStoryTree,
    name: 'The Silent Story Tree',
    curriculumFocus: ['sequence of events', 'narrative comprehension'],
    openingChallengeId: SILENT_STORY_TREE_TRAIL.id,
    availableInFoundation: true,
  },
  {
    id: STORY_FOREST_DISTRICTS.wordGarden,
    name: 'Word Garden',
    curriculumFocus: ['vocabulary', 'context clues'],
    openingChallengeId: WORD_GARDEN_CONTEXT_1.id,
    availableInFoundation: true,
  },
  { id: STORY_FOREST_DISTRICTS.soundingStones, name: 'Sounding Stones', curriculumFocus: ['phonics', 'decoding'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.fluencyFalls, name: 'Fluency Falls', curriculumFocus: ['accuracy', 'expression', 'rate'], availableInFoundation: false },
  {
    id: STORY_FOREST_DISTRICTS.characterGrove,
    name: 'Character Grove',
    curriculumFocus: ['character response', 'story evidence'],
    openingChallengeId: CHARACTER_GROVE_RESPONSE_1.id,
    availableInFoundation: true,
  },
  { id: STORY_FOREST_DISTRICTS.informationalTrail, name: 'Informational Trail', curriculumFocus: ['main idea', 'key details', 'text features'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.writersHollow, name: "Writer's Hollow", curriculumFocus: ['written response', 'composition'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.libraryCanopy, name: 'Library Canopy', curriculumFocus: ['genre', 'independent reading'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.masteryGrove, name: 'Mastery Grove', curriculumFocus: ['review', 'mastery'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.sequenceStream, name: 'Sequence Stream', curriculumFocus: ['event order', 'cause and effect'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.mainIdeaMeadow, name: 'Main Idea Meadow', curriculumFocus: ['main idea', 'supporting details'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.inferenceHollow, name: 'Inference Hollow', curriculumFocus: ['inference', 'text evidence'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.authorsCabin, name: "Author's Cabin", curriculumFocus: ['point of view', 'author purpose', 'text features'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.grammarGlade, name: 'Grammar Glade', curriculumFocus: ['sentence structure', 'parts of speech', 'punctuation'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.fluencyLanternPath, name: 'Fluency Lantern Path', curriculumFocus: ['phrasing', 'expression', 'high-frequency words'], availableInFoundation: false },
  { id: STORY_FOREST_DISTRICTS.greatStoryTree, name: 'Great Story Tree', curriculumFocus: ['mixed reading mastery'], availableInFoundation: false },
];

export const STORY_FOREST_OPENING = {
  districtId: STORY_FOREST_DISTRICTS.silentStoryTree,
  landmarkName: 'Story Tree',
  challenge: SILENT_STORY_TREE_TRAIL,
} as const;

export const STORY_FOREST_WORD_GARDEN = {
  districtId: STORY_FOREST_DISTRICTS.wordGarden,
  challenge: WORD_GARDEN_CONTEXT_1,
} as const;

export const STORY_FOREST_CHARACTER_GROVE = {
  districtId: STORY_FOREST_DISTRICTS.characterGrove,
  challenge: CHARACTER_GROVE_RESPONSE_1,
} as const;
